export default __webpack_public_path__ + "static/sv-034fabc522f105f4c8607f35788250c8.svg";